module.exports = __webpack_public_path__ + "img/w3_phone_white.f62ae64d.png";